import { Inject, Injectable } from '@angular/core';
import { HttpInterceptorService } from '../../../../core/services/http-interceptor.service';
import { Observable } from 'rxjs';
import { AuthenticationService } from '@ispm/user/services/authentication.service';

@Injectable()
export class WorkflowBarService {

  constructor(private _http: HttpInterceptorService) {
  }
  static wfURLSuffix = '/workflow/getWorkflowBarItems';

  public getWorkflowBarItems(workflowId: string, revisionId: string, toggleLoader: boolean = false): Observable<any> {
    return this._http.get(WorkflowBarService.wfURLSuffix, {
      workflowId: workflowId,
      revisionId: revisionId
    }, toggleLoader)
      .map(res => res.json())
      .catch(err => null);
  }


}
